import { render, staticRenderFns } from "./FeedReviews.vue?vue&type=template&id=7a82510f&"
import script from "./FeedReviews.vue?vue&type=script&lang=ts&"
export * from "./FeedReviews.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports